import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import useClasses from '../../../hooks/useClasses';
import FrontPageHero from './Hero';
import { ImmutableGenericNodeEntity } from '..';

import './style.scss';
import { Main } from '../../../components';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeFrontPage: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('NodeFrontPage');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const paragraphs = entity.get('field_paragraphs', Immutable.List());
  const svg = entity.getIn(['field_media_item', 0, 'entity', 'field_media_file', 0], Immutable.Map());

  const paragraphPrograms = paragraphs.filter((value) => value.getIn(['entity', 'type', 0, 'target_id']) === 'frontpage_programs');
  const otherParagraphs = paragraphs.filter((value) => value.getIn(['entity', 'type', 0, 'target_id']) !== 'frontpage_programs');

  return (
    <Main className={joinClasses(buildClass(), className)}>

      <FrontPageHero
        title={title}
        body={body}
        paragraphs={paragraphPrograms}
        svg={svg}
      />

      <Container>
        {otherParagraphs.size > 0 && (
          <div className={buildClass('paragraphs')}>
            {otherParagraphs.map((paragraph, index) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  id={id}
                  entity={paragraph.get('entity')}
                  index={index}
                />
              );
            })}
          </div>
        )}
      </Container>
    </Main>
  );
};

export default NodeFrontPage;
